import { createSelector } from 'reselect';
import { OneTrustReducerState } from './oneTrustReducer';
import { OneTrustConsentModel, OneTrustStatus } from './oneTrustTypes';
import type { ReduxState } from '../../types/reduxTypes';

const getOneTrustState = (state: ReduxState): OneTrustReducerState => state.getIn(['oneTrust']);

export const isOneTrustStatus = (status: OneTrustStatus) =>
    createSelector(getOneTrustState, (oneTrustState) => oneTrustState.status === status);

export const isOneTrustInitialised = isOneTrustStatus(OneTrustStatus.INITIALISED);
export const isOneTrustError = isOneTrustStatus(OneTrustStatus.ERROR);

export const getOneTrustConsentModel = createSelector(getOneTrustState, (oneTrustState) => oneTrustState.consentModel);
export const getShowOneTrustBanner = createSelector(getOneTrustState, (oneTrustState) => oneTrustState.showBanner);

export const getShowMandatoryCookieBanner = createSelector(
    getShowOneTrustBanner,
    getOneTrustConsentModel,
    (showBanner, consentModel) => {
        return showBanner && consentModel === OneTrustConsentModel.OPT_IN;
    },
);

export const getShowOptionalCookieBanner = createSelector(
    getShowOneTrustBanner,
    getOneTrustConsentModel,
    (showBanner, consentModel) => {
        return showBanner && consentModel !== OneTrustConsentModel.OPT_IN;
    },
);
